<template>
    <div>
        <div class="tab-top">
            <h2>{{ $t('custom-contract.upload.headline') }}</h2>
            <p>{{ $t('custom-contract.upload.text') }}</p>
        </div>
        <div class="seperator"></div>
        <div class="wizard-component">
            <vue-dropzone
                id="customContractUploadDropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-file-added="progress"
                v-on:vdropzone-success="success"
                v-on:vdropzone-error="error"
            />
            <div v-if="loading" class="upload-loader">
                <Loader></Loader>
            </div>
        </div>
    </div>
</template>
<script>

import vue2Dropzone from 'vue2-dropzone'
import {mapGetters} from "vuex";

import Loader from "../../../components/Loader";

export default {
    data: () => ({
        loading: false
    }),
    name: "CustomContractUpload",
    components: {
        vueDropzone: vue2Dropzone,
        Loader
    },
    props: ['value', 'property'],
    computed: {
        dropzoneOptions() {
            return {
                url: window.config.apiUrl + 'api/custom-contract',
                method: 'post',
                paramName: 'document',
                acceptedFiles: 'application/pdf',
                dictDefaultMessage: this.$t('label.upload.placeholder'),
                timeout: 0,
                params: {
                    property_id: this.property.id
                },
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                }
            };
        },
        ...mapGetters(['getToken'])
    },
    methods: {
        success: function (file, response) {
            this.$emit('input', response.data)
            this.$emit('success')
        },
        progress: function(file) {
            this.loading = true;
        },
        error: function (file, message, xhr) {
            this.$emit('error', 'Error uploading the file');
        }
    }
}
</script>

<style scoped>

</style>
